@if (patient) {
  <div class="phi">
    <div>
      @if (canViewPatient) {
        <a
          target="_blank"
          routerLink="/capture-admin/patients/{{ patient.id }}"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >{{ visiblePatient.fullName }}</a>
      } @else {
        {{ visiblePatient.fullName }}
      }
    </div>
    @if (matchedName) {
      <div class="small text-nowrap"><strong>Matched:</strong> {{ matchedName }}</div>
    }
    <div class="small text-nowrap" [title]="mrnDisplayCharacters < INFINITY ? visiblePatient.mrn : ''">
      <strong>MRN:</strong>
      {{ visiblePatient.mrn | leftTruncate:mrnDisplayCharacters }}
    </div>
    <div class="small text-nowrap"><strong>DOB:</strong> {{ visiblePatient.dob | date: 'MM/dd/yyyy' }}</div>
    @if (showAlternateNames) {
      <app-patient-alternate-names [patient]="visiblePatient" />
    }
  </div>
} @else {
  <div><app-blank-value-dash /></div>
}

